/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9c5a7c5f (Mon Apr 13 19:32:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  FetchLicensedDirectorBillingDetailsResponseDirector,
  FetchLicensedDirectorBillingDetailsResponseDirectorFromJSON,
  FetchLicensedDirectorBillingDetailsResponseDirectorToJSON,
  FetchLicensedDirectorBillingDetailsResponseTutors,
  FetchLicensedDirectorBillingDetailsResponseTutorsFromJSON,
  FetchLicensedDirectorBillingDetailsResponseTutorsToJSON,
  ProgramType,
} from './'

/**
 *
 * @export
 * @interface FetchLicensedDirectorBillingDetailsResponse
 */
export interface FetchLicensedDirectorBillingDetailsResponse {
  /**
   * The Community name managed by the director
   * @type string
   * @memberof FetchLicensedDirectorBillingDetailsResponse
   */
  community: string
  /**
   * Start date of the program's first semester.
   * @type Date
   * @memberof FetchLicensedDirectorBillingDetailsResponse
   */
  semesterOneStartDate: Date
  /**
   *
   * @type ProgramType
   * @memberof FetchLicensedDirectorBillingDetailsResponse
   */
  programType: ProgramType
  /**
   *
   * @type FetchLicensedDirectorBillingDetailsResponseDirector
   * @memberof FetchLicensedDirectorBillingDetailsResponse
   */
  director: FetchLicensedDirectorBillingDetailsResponseDirector
  /**
   * List of tutors associated with the director
   * @type {Array<FetchLicensedDirectorBillingDetailsResponseTutors>}
   * @memberof FetchLicensedDirectorBillingDetailsResponse
   */
  tutors: Array<FetchLicensedDirectorBillingDetailsResponseTutors>
}

export function FetchLicensedDirectorBillingDetailsResponseFromJSON(
  json: any
): FetchLicensedDirectorBillingDetailsResponse {
  return FetchLicensedDirectorBillingDetailsResponseFromJSONTyped(json, false)
}

export function FetchLicensedDirectorBillingDetailsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchLicensedDirectorBillingDetailsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    community: json['community'],
    semesterOneStartDate: new Date(json['semesterOneStartDate']),
    programType: json['programType'],
    director: FetchLicensedDirectorBillingDetailsResponseDirectorFromJSON(
      json['director']
    ),
    tutors: (json['tutors'] as Array<any>).map(
      FetchLicensedDirectorBillingDetailsResponseTutorsFromJSON
    ),
  }
}

export function FetchLicensedDirectorBillingDetailsResponseToJSON(
  value?: FetchLicensedDirectorBillingDetailsResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    community: value.community,
    semesterOneStartDate: value.semesterOneStartDate
      .toISOString()
      .substr(0, 10),
    programType: value.programType,
    director: FetchLicensedDirectorBillingDetailsResponseDirectorToJSON(
      value.director
    ),
    tutors: (value.tutors as Array<any>).map(
      FetchLicensedDirectorBillingDetailsResponseTutorsToJSON
    ),
  }
}
